var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-10 h-100",attrs:{"component":_vm.$options.name}},[_c('app-common-api-health-items',{attrs:{"providers":_vm.providers,"layout":"alt"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }